import { render, staticRenderFns } from "./popRights.vue?vue&type=template&id=69dd5f00&scoped=true"
import script from "./popRights.vue?vue&type=script&lang=js"
export * from "./popRights.vue?vue&type=script&lang=js"
import style0 from "./popRights.vue?vue&type=style&index=0&id=69dd5f00&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dd5f00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69dd5f00')) {
      api.createRecord('69dd5f00', component.options)
    } else {
      api.reload('69dd5f00', component.options)
    }
    module.hot.accept("./popRights.vue?vue&type=template&id=69dd5f00&scoped=true", function () {
      api.rerender('69dd5f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equityPopup/popRights.vue"
export default component.exports